import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { cssColor, cssTextColor } from "../colors/colorUtils";
import styles from "./Badge.module.scss";
export default function Badge(_a) {
    var { color = "normal", textColor = color, flat = false, children } = _a, props = __rest(_a, ["color", "textColor", "flat", "children"]);
    return (_jsx("div", Object.assign({}, props, { style: Object.assign({ background: cssColor(color), color: cssTextColor(textColor) }, props.style), className: clsx(styles.badge, props.className, flat && styles.flat), children: children })));
}
